/* global $ */
var Proj = (function(proj){
    'use strict';

    proj.Calculator = function() {
        var $selector =  $('.js-calculate');
        $('.js-calculate-max').hide();
        $('.js-calculate-success').hide();

        if ($selector.length) {
            var $calc = $();

            $selector.mouseenter(function(){
                $calc = $(this).closest('.calculators__block');
                $calc.addClass('m--hovered');
            });
            $selector.mouseleave(function(){
                $calc = $(this).closest('.calculators__block');
                $calc.removeClass('m--hovered');
            });

            $selector.click(function(){
                $('.calculators__block').each(function(index, el) {
                    var $this = $(this);
                    if ( !$this.hasClass('m--minwidth') ) {
                        $this.addClass('m--minwidth');
                        $this.removeClass('m--fullwidth');
                        $this.find('.js-calculate-min').show();
                        $this.find('.js-calculate-max').hide();
                        $this.find('.js-calculate-success').hide();
                    }
                });

                $calc = $(this).closest('.calculators__block');
                if ($calc.hasClass('m--minwidth')) {
                    $calc.removeClass('m--minwidth');
                    $calc.addClass('m--fullwidth');
                    $calc.find('.js-calculate-min').fadeOut(300);
                    setTimeout(function() {
                        $calc.find('.js-calculate-max').fadeIn(300);
                    }, 400);
                }
            });

            var $close = $('.js-calc-close');
            $close.click(function(){
                $calc = $(this).closest('.calculators__block');
                $calc.addClass('m--minwidth');
                $calc.removeClass('m--fullwidth');
                $calc.find('.js-calculate-min').fadeIn(300);
                $calc.find('.js-calculate-max').hide();
                $calc.find('.js-calculate-success').hide();
                $('.allblack_mob').fadeOut(300);
                $('.allblack').fadeOut(300);
            });

            $('.js-calculate-btn').click(function(e){
                e.preventDefault();
                var $calc = $(this).closest('.calculators__block');
                var $data_block = $(this).parents('.calculators__item');

                var data_price = parseFloat( $data_block.attr('data-square-price') );
                var multiplicator_paint = parseFloat( $data_block.attr('data-multiplicator-paint') );
                var input_val =  parseInt( $data_block.find('.calculators__square input').val() );
                var $paint = 0;

                if ( $data_block.find('.input_colored:checked').length > 0 ) {
                    $paint = 1;
                }

                if (input_val > 0) {
                    var res = input_val*data_price;

                    if ($paint == 1) {
                        res = res*multiplicator_paint;
                        $data_block.find('.calculators__result.m--color strong').html('да');
                    } else {
                        $data_block.find('.calculators__result.m--color strong').html('нет');
                    }
                    res = parseInt(res);
                    $data_block.find('.calculators__result.m--val strong').html(proj.toPrice({ price: input_val,
                                                                                               no_tags: true,
                                                                                               sign: 'м²' }));
                    $data_block.find('.calculators__result.m--price strong').html(proj.toPrice({ price: res,
                                                                                                 no_tags: true,
                                                                                                 sign: 'р.' }));


                    $calc.find('.js-calculate-max').fadeOut(300);
                    setTimeout(function() {
                        $calc.find('.js-calculate-success').fadeIn(300);
                    }, 300);
                }

            });

            $('.js-calc-recount').click(function(e){
                $calc = $(this).closest('.calculators__block');
                $calc.find('.js-calculate-success').fadeOut(300);
                setTimeout(function() {
                    $calc.find('.js-calculate-max').fadeIn(300);
                }, 300);
            });

        }
    };

    return proj;
})(Proj || {});



